import React from 'react';
import iconBathtub from '../../../images/icon-bathtub.svg';
import iconBed from '../../../images/icon-bed.svg';
import iconFt from '../../../images/icon-ft.svg';
import Slider from '../../common/slider/Slider';
import styles from './CustomUnitCard.module.css';
import { UnitStatus } from './Unitscard';

export interface units {
    baths: number;
    id: string;
    image_url?: string;
    name: string;
    price: number;
    rooms: number;
    size: number;
    nickName: string;
    unitYardiId?: string | null;
    availability: any;
    unit_status: UnitStatus;
}

interface props {
    unit: units;
    onClick?: (id: string) => void;
    selected?: boolean;
    noPointer?: boolean;
    lastUnitsRef?: any;
}

export interface LockerData {
    locker: number;
    startDate: string;
    availabilityId: string;
}

const CustomUnitscard = ({ unit, onClick, selected, noPointer, lastUnitsRef }: props) => {
    const uniqueLockers: string = [...new Set<number>(unit?.availability?.map((item: LockerData) => item.locker))].join(" ");

    return (
        <div
            ref={lastUnitsRef}
            className={`${styles.unitcardMain} ${noPointer ? styles.noPointer : ''}`}
            onClick={() => { unit?.unit_status === 'available' && onClick?.(unit?.id) }}>
            <div className={`${styles.unitcard} ${selected ? styles.selected : ''}`}>
                <div className={styles.cardBanner}>
                    <div className={styles.bannerMain}>
                        <div className={`${styles.statusBadge}
                             ${unit?.unit_status === 'available'
                                ? styles.green
                                : unit?.unit_status === 'occupied'
                                    ? styles.yellow
                                    : styles.red
                            }`}
                        >{unit?.unit_status === 'occupied' ? 'Occupied' : unit?.unit_status}</div>
                        <Slider carouselBanner={unit?.image_url?.trim() ? unit?.image_url : ""} price={unit?.price} />
                        {!!unit?.price && <span className={styles.cost}>{`$ ${unit?.price}`}</span>}
                    </div>
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.cardTitle}>
                        <div className={styles.link}></div>
                    </div>
                    <div className={styles.inlineItemWrapper}>
                        <div className={styles.link}>
                            <p>
                                <span className={styles.locationName}>
                                    {unit?.unitYardiId ? unit?.unitYardiId : unit?.name || 'Location'}{' '}
                                    {unit?.nickName && ` "${unit?.nickName}"`}
                                </span>
                            </p>
                        </div>

                        {/* Locker icon and availability */}
                        {unit?.availability && unit?.availability?.length > 0 && (
                            <div className={styles.lockerInfoContainer}>
                                <i className="fas fa-lock"></i> {/* Lock Icon */}
                                {uniqueLockers?.length > 1 ? (
                                    <>
                                        <span className={styles.lockerM}>M</span>
                                    </>
                                ) : (
                                    <span className={styles.lockerSpan}>{unit?.availability[0]?.locker}</span>
                                )}
                                {uniqueLockers?.length > 1 && <div className={styles.tooltip}>{uniqueLockers}</div>}
                            </div>
                        )}
                    </div>

                    <div className={styles.cardFacilities}>
                        <div className={styles.facility}>
                            <img src={iconFt} />
                            <div className={styles.link}>
                                <span>{`${unit?.size || 0}  Sq Ft`}</span>
                            </div>
                        </div>
                        <div className={styles.facility}>
                            <img src={iconBed} />
                            <div className={styles.link}>
                                {unit?.rooms && unit?.rooms > 0 ? <span>{`${unit?.rooms} Beds`}</span> : 'Studio'}
                            </div>
                        </div>
                        <div className={styles.facility}>
                            <img src={iconBathtub} />
                            <div className={styles.link}>
                                {(+unit?.baths || +unit?.baths === 0) && (
                                    <span>{`${+unit?.baths} ${+unit?.baths === 1 ? 'Bath' : 'Baths'}`}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomUnitscard;
